import { Injectable } from '@angular/core';
import { RestServiceV2 } from '../../../core/services/restV2.service';
import { ActividadEconomica, CatalogoCodigosPostales, CatalogoColonia, CatalogoEstados, 
    CatalogoMunicipio, CatalogoPaises, GiroMercantil } from '../../../core/interfaces/interfaces.interface';
import { SearchCP } from '../../../core/interfaces/address.interface';


@Injectable({providedIn: 'root'})
export class CatalogoService {
    private paisesCache: CatalogoPaises[] | null = null;

    constructor(
        private restService: RestServiceV2
    ) { }
    

    getCatalogosAmda():Promise<{actividadesEconomicas:ActividadEconomica[], giroMercantil:GiroMercantil[]} | null>{
        return this.restService.get('/catalogos/pedido-amda')
    }

    getCatalogoPaises(): Promise<CatalogoPaises[] | null> {
        if (this.paisesCache) {
            return Promise.resolve(this.paisesCache);
        }
        return this.restService.get('/catalogos/address/paises').then(result => {
            if (result) {
                this.paisesCache = result;
            }
            return result;
        });
    }

    getCatalogoEstados(pais:string):Promise<CatalogoEstados[] | null>{
        return this.restService.get(`/catalogos/address/estados?pais=${pais}`)
    }

    getCatalogoMunicipio(estado:string):Promise<CatalogoMunicipio[] | null>{
        return this.restService.get(`/catalogos/address/municipios?estado=${estado}`)
    }

    getCodigosPostales(municipio:string):Promise<CatalogoCodigosPostales[] | null>{
        return this.restService.get(`/catalogos/address/codigos_postales?municipio=${municipio}`)
    }

    getCatalogoColonias(codigoPostal:string):Promise<CatalogoColonia[] | null>{
        return this.restService.get(`/catalogos/address/colonias?codigoPostal=${codigoPostal}`)
    }

    searchByCP(cp:string):Promise<SearchCP | null>{
        return this.restService.get(`/catalogos/address/search_cp?codigoPostal=${cp}`)
    }

    addColonia(codigoPostal:string, value:string):Promise<CatalogoColonia | null>{
        return this.restService.post(`/catalogos/address/colonias`, {codigoPostal, colonia : value})
    }

    addCodigoPostal(estado:string, municipio:string, value:string):Promise<CatalogoCodigosPostales | null>{
        return this.restService.post(`/catalogos/address/codigos_postales`, {estado, municipio, codigoPostal : value})
    }

    getCatalogoNacionalidades():Promise<{id:string, nacionalidad:string}[] | null>{
        return this.restService.get('/catalogos/address/nacionalidades')
    }
}